import { FabricObject } from 'fabric'

export const CANVAS_CONFIG = {
  height: 794,
  width: 1123,
  renderOnAddRemove: true,
  preserveObjectStacking: true,
  shouldEmbedFontDefinition: false,
  alignGuideline: {
    /** At what distance from the shape does alignment begin? */
    margin: 4,
    /** Aligning line dimensions */
    width: 1,
    /** Aligning line color */
    color: 'rgb(255,0,0,0.9)',
  },
  imageSizeLimitInMB: 5,
  imageAllowedType: ['image/jpeg', 'image/png', 'image/svg+xml'],
}

export const COMPONENT_LABEL: Partial<Record<FabricObject['type'], string>> = {
  image: 'Gambar',
  textbox: 'Teks',
  text: 'Non-edit Teks',
}

export const CONTROL_CONFIG = {
  grid: 40,
  snap: true,
  snapThreshold: 3,
  snapAngle: 45,
}

export const CANVAS_TAB_ID: { [key: string]: string } = {
  '-1': 'canvas-page',
  0: 'canvas-front-page',
  1: 'canvas-back-page',
}

export const TEMPLATE_BUILDER_GLOBAL_SNAPSHOT_LS_KEY =
  'TEMPLATE_BUILDER_GLOBAL_SNAPSHOT'

export const FONT_FACE = {
  Inter: [
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Thin_100.ttf',
      style: 'normal',
      weight: '100',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-ExtraLight_200.ttf',
      style: 'normal',
      weight: '200',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Light_300.ttf',
      style: 'normal',
      weight: '300',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Regular_400.ttf',
      style: 'normal',
      weight: '400',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Medium_500.ttf',
      style: 'normal',
      weight: '500',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-SemiBold_600.ttf',
      style: 'normal',
      weight: '600',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Bold_700.ttf',
      style: 'normal',
      weight: '700',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-ExtraBold_800.ttf',
      style: 'normal',
      weight: '800',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Black_900.ttf',
      style: 'normal',
      weight: '900',
    },
    // ITALIC
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-ThinItalic_100.ttf',
      style: 'italic',
      weight: '100',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-ExtraLightItalic_200.ttf',
      style: 'italic',
      weight: '200',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-LightItalic_300.ttf',
      style: 'italic',
      weight: '300',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-Italic_400.ttf',
      style: 'italic',
      weight: '400',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-MediumItalic_500.ttf',
      style: 'italic',
      weight: '500',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-SemiBoldItalic_600.ttf',
      style: 'italic',
      weight: '600',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-BoldItalic_700.ttf',
      style: 'italic',
      weight: '700',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-ExtraBoldItalic_800.ttf',
      style: 'italic',
      weight: '800',
    },
    {
      url:
        process.env.NEXT_PUBLIC_CDN_LMS_URL +
        '/fonts/Inter/Inter_18pt-BlackItalic_900.ttf',
      style: 'italic',
      weight: '900',
    },
  ],
}

export const CANVAS_PREVIEW_DOM_ID = {
  'canvas-front-page': 'template-front-preview-placeholder',
  'canvas-back-page': 'template-back-preview-placeholder',
}

export const CANVAS_BROKEN_IMAGE_BASE64 = `data:image/png;base64,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`

export const QR_CODE_CERTIFICATE_KEY = 'QR_CODE_CERTIFICATE'
export const QR_CODE_CERTIFICATE_EXAMPLE_BASE64 = `data:image/png;base64,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`
